import { useInviteLandlords } from '@services/users/mutations'
import { Mail } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { UserDetail } from 'types/api'

import { Button } from '@/components/ui/button'
import { useConfirmLandlordInvite } from '../hooks/useConfirmLandlordInvite'
import { LandlordAccountStatus } from './LandlordAccountStatus'

/** Account status plus the button that e-mails a create-password link. */
export function LandlordInviteButton({ landlord }: { landlord: UserDetail }) {
  const { t } = useTranslation('users')
  const { mutate: inviteLandlords, isPending } = useInviteLandlords()
  const { confirmInvite, dialog } = useConfirmLandlordInvite()

  async function handleInvite() {
    if (!landlord.id || !(await confirmInvite(1))) return
    inviteLandlords({ user_ids: [landlord.id] })
  }

  return (
    <div className="flex shrink-0 items-center gap-3">
      <LandlordAccountStatus landlord={landlord} />
      <Button
        size="sm"
        onClick={handleInvite}
        disabled={
          isPending || !!landlord.last_login || !!landlord.landlord_inactive
        }
        title={
          landlord.last_login
            ? t('landlordInvite.alreadyLoggedIn')
            : landlord.landlord_inactive
              ? t('landlordInvite.landlordInactive')
              : undefined
        }
      >
        <Mail className="h-4 w-4" />
        {t('landlordInvite.action')}
      </Button>
      {dialog}
    </div>
  )
}
